import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWindows11 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M4 4v20h20V4H4zm22 0v20h20V4H26zM6 6h16v16H6V6zm22 0h16v16H28V6zM4 26v20h20V26H4zm22 0v20h20V26H26zM6 28h16v16H6V28zm22 0h16v16H28V28z" />
    </svg>
);
export default SvgWindows11;
